import React, { useEffect } from 'react';
import useCollapsibleOverlay from '../../../../hooks/useCollapsibleOverlay';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { Namespace } from '../../../../translation/namespace';
import { Icons } from '../../../../components/atoms/SVG';
import { CollapsibleContent } from '../../../../components/organisms/CollapsibleOverlay/CollapsibleOverlay';
import { ButtonMinorAction } from '../../../../components/molecules/Btn/ButtonWrapper';
import { TextSnippet, TextSnippetModifier } from '../../../../components/molecules/SearchResultTeaser/TextSnippet';
import { TooltipPlacement } from '../../../../components/atoms/Tooltip';

type AttachmentSnippet = {
  snippet: string;
  title: string;
};

export function DownloadAttachmentSnippet({ snippet, title }: AttachmentSnippet) {
  const { t } = useSonTranslation(Namespace.ContentAttachmentList);
  const { collapsibleProps, toggleProps, collapsibleOpen, popperInstance } = useCollapsibleOverlay('bottom');

  useEffect(() => {
    if (collapsibleOpen && popperInstance) {
      popperInstance.update();
    }
  });

  const text = t('searchHit', { title });
  return (
    <div className="download__snippet-text-button">
      <ButtonMinorAction
        icon={collapsibleOpen ? Icons.DECLINE_CROSS : Icons.SEARCH_HIT}
        text={text}
        onClick={toggleProps.onClick}
        tooltipPlacement={TooltipPlacement.TOP}
      />
      <CollapsibleContent {...collapsibleProps}>
        <TextSnippet text={snippet} modifier={TextSnippetModifier.COLLAPSIBLE} />
      </CollapsibleContent>
    </div>
  );
}
